import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import s from './HeroCarousel.module.css';

const SLIDES = [
  {
    bg: '/images/banner1.jpg',
    eyebrow: "Flourtown's Most Trusted Practice",
    title: "Your Smile.\nOur <em>Passion.</em>",
    sub: 'A dedicated dental practice specializing in general, family, and special care dentistry—built on a foundation of empathy, transparency, and advanced technology.',
  },
  {
    bg: '/images/banner2.jpg',
    eyebrow: 'Special Care Dentistry Experts',
    title: "Gentle Care for\n<em>Every Patient.</em>",
    sub: 'Expert dental care for patients with autism, dementia, Down Syndrome, and other special needs. Where every patient is treated with dignity.',
  },
  {
    bg: '/images/banner3.jpg',
    eyebrow: 'Advanced Technology & Techniques',
    title: "The Smile You\n<em>Deserve.</em>",
    sub: 'From GentleWave root canals to KöR Whitening and Orthosnap clear aligners — experience dentistry at its finest.',
  },
];

export default function HeroCarousel() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => setCurrent(c => (c + 1) % SLIDES.length), []);

  useEffect(() => {
    const timer = setInterval(next, 5500);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <section className={s.hero} aria-label="Hero">
      {SLIDES.map((slide, i) => (
        <div key={i} className={`${s.slide} ${i === current ? s.active : ''}`}>
          <div className={s.bg} style={{ backgroundImage: `url(${slide.bg})` }} />
          <div className={s.overlay} />
        </div>
      ))}

      <div className={`${s.content} container`}>
        <p className={s.eyebrow}>{SLIDES[current].eyebrow}</p>
        <h1
          className={s.h1}
          dangerouslySetInnerHTML={{ __html: SLIDES[current].title.replace('\n', '<br/>') }}
        />
        <p className={s.sub}>{SLIDES[current].sub}</p>
        <div className={s.actions}>
          <Link to="/book-appointment" className="btn btn-primary btn-primary-lg">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            Request Appointment
          </Link>
          <Link to="/services" className="btn btn-outline-white">Explore Services</Link>
        </div>
      </div>

      <div className={s.dots}>
        {SLIDES.map((_, i) => (
          <button
            key={i}
            className={`${s.dot} ${i === current ? s.dotActive : ''}`}
            onClick={() => setCurrent(i)}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>

      <div className={s.card}>
        <div className={s.cardTag}>Ready to Visit?</div>
        <div className={s.cardTitle}>Plan Your Visit</div>
        <div className={s.cardSub}>New patients welcome · Same-day emergency slots available</div>
        <Link to="/book-appointment" className="btn btn-primary" style={{width:'100%',justifyContent:'center',fontSize:'12px'}}>Book Now →</Link>
      </div>
    </section>
  );
}
